import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiDroplet,FiShield,FiAward}=FiIcons;

const Hero=()=> {
  return ( 
    <section className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white"> 
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20"> 
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"> 
          <motion.div 
            initial={{opacity: 0,x: -50}} 
            animate={{opacity: 1,x: 0}} 
            transition={{duration: 0.8}} 
          > 
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight"> 
              Professional Water Treatment Solutions 
            </h1> 
            <p className="text-xl mb-8 text-blue-100"> 
              Shanghai Minipore Industrial Co.,Ltd. - Your trusted partner for high-quality water treatment equipment and consumables worldwide. 
            </p> 
            <div className="flex flex-wrap gap-4"> 
              <Link to="/products" className="bg-white text-blue-900 px-8 py-3 rounded-full font-semibold hover:bg-blue-50 transition-colors inline-block" > 
                Explore Products 
              </Link> 
              <Link to="/contact" className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-blue-900 transition-colors inline-block" > 
                Contact Us 
              </Link> 
            </div> 
          </motion.div> 
          <motion.div 
            initial={{opacity: 0,x: 50}} 
            animate={{opacity: 1,x: 0}} 
            transition={{duration: 0.8,delay: 0.2}} 
            className="relative" 
          > 
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8"> 
              <div className="grid grid-cols-1 gap-6"> 
                <div className="flex items-center space-x-4"> 
                  <div className="bg-blue-500 p-3 rounded-full"> 
                    <SafeIcon icon={FiDroplet} className="h-6 w-6 text-white" /> 
                  </div> 
                  <div> 
                    <h3 className="font-semibold text-lg">Premium Quality</h3> 
                    <p className="text-blue-100">ISO9001:2008 certified products</p> 
                  </div> 
                </div> 
                <div className="flex items-center space-x-4"> 
                  <div className="bg-blue-500 p-3 rounded-full"> 
                    <SafeIcon icon={FiShield} className="h-6 w-6 text-white" /> 
                  </div> 
                  <div> 
                    <h3 className="font-semibold text-lg">Reliable Solutions</h3> 
                    <p className="text-blue-100">Advanced ERP management system</p> 
                  </div> 
                </div> 
                <div className="flex items-center space-x-4"> 
                  <div className="bg-blue-500 p-3 rounded-full"> 
                    <SafeIcon icon={FiAward} className="h-6 w-6 text-white" /> 
                  </div> 
                  <div> 
                    <h3 className="font-semibold text-lg">Global Reach</h3> 
                    <p className="text-blue-100">Export-oriented environmental protection</p> 
                  </div> 
                </div> 
              </div> 
            </div> 
          </motion.div> 
        </div> 
      </div> 
    </section> 
  );
};

export default Hero;